module.exports = __webpack_public_path__ + "img/iphone.b8d01f6e.png";